import React, { useCallback, useRef, useState } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import moment from "moment";
import ja from "date-fns/locale/ja";
registerLocale("ja", ja);

import axios from "../../sagas/axios";
import Contents from '../../../contents/index';
import ModalAlert from "../../components/modal/modal_alert";
import ModalLoader from "../../../modal/modal_loader";

const Edit = ({ article, isApp, userAgent }) => {
  const [urlKey, setUrlKey] = useState(article.url_key || "");
  const [categoryId, setCategoryId] = useState(
    article.articles_category_id || ""
  );
  const [title, setTitle] = useState(article.title || "");
  const [description, setDescription] = useState(article.description || "");
  const [publishDatetime, setPublishDatetime] = useState(
    article.publish_datetime
      ? moment(article.publish_datetime).toDate()
      : new Date()
  );
  const [keyvisualUrl, setKeyvisualUrl] = useState(article.keyvisual_url || "");
  const [sortOrder, setSortOrder] = useState(article.sort_order || 0);
  const [isPublishDateDisplay, setIsPublishDateDisplay] = useState(
    article.is_publish_date_display || false
  );
  const [hideBreadcrumb, setHideBreadcrumb] = useState(
    article.hide_breadcrumb || false
  );
  const [isDeleted, setIsDeleted] = useState(article.is_deleted || false);
  const [isHeaderNoindex, setIsHeaderNoindex] = useState(article.is_header_noindex || false);
  const [isNextButtonDisplayed, setIsNextButtonDisplayed] = useState(true);

  const successRef = useRef(null);
  const errorRef = useRef(null);
  const loaderRef = useRef(null);

  const onSubmit = useCallback(
    (e) => {
      e.preventDefault();
      loaderRef.current.openModal();
      const body = JSON.stringify({
        url_key: urlKey,
        articles_category_id: categoryId,
        title,
        description,
        publish_datetime: publishDatetime,
        is_publish_date_display: isPublishDateDisplay,
        hide_breadcrumb: hideBreadcrumb,
        is_deleted: isDeleted,
        is_header_noindex: isHeaderNoindex,
        keyvisual_url: keyvisualUrl,
        sort_order: sortOrder,
      });
      axios
        .post(`/api/articles/${article.id}/update`, body)
        .then((response) => {
          loaderRef.current.closeModal();
          if (response.status === 200) {
            successRef.current.openModal();
          } else {
            errorRef.current.openModal();
          }
        })
        .catch(() => {
          loaderRef.current.closeModal();
          errorRef.current.openModal();
        });
    },
    [
      loaderRef,
      successRef,
      errorRef,
      article,
      urlKey,
      categoryId,
      title,
      description,
      publishDatetime,
      isPublishDateDisplay,
      hideBreadcrumb,
      isDeleted,
      isHeaderNoindex,
      keyvisualUrl,
      sortOrder,
    ]
  );

  const toArticlesPage = useCallback(
    () => {
      window && (window.location.href = `/article/preview/${urlKey}`);
    },
    [urlKey]
  );

  return (
    <div>
      <main
        style={{ paddingBottom: isApp == false ? "165px" : "66px" }}
        className="bg-gray h-100 pt-3 min-vh-100"
      >
        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
            記事のタイトル
            <span className="message-required d-inline-block mb-2 ml-2">
              必須
            </span>
          </p>
        </div>
        <div className="shadow-sm mb-0 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
            <input
              type="text"
              className="p-0 w-100 textarea--eventreport"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </div>
        </div>
        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
            サブカテゴリーID（設定しないと単発記事に）
          </p>
        </div>
        <div className="shadow-sm mb-0 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
            <input
              type="text"
              className="p-0 w-100 textarea--eventreport"
              value={categoryId}
              onChange={(e) => setCategoryId(e.target.value)}
            />
          </div>
        </div>

        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
            URLキー
            <span className="message-required d-inline-block mb-2 ml-2">
              必須
            </span>
          </p>
        </div>
        <div className="shadow-sm mb-0 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
            <input
              type="text"
              className="p-0 w-100 textarea--eventreport"
              value={urlKey}
              onChange={(e) => setUrlKey(e.target.value)}
            />
          </div>
        </div>
        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
            サムネイルURL (記事の文中の画像ではなくサムネイルの画像として使用します)
          </p>
        </div>
        <div className="shadow-sm mb-0 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
            <input
              type="text"
              className="p-0 w-100 textarea--eventreport"
              value={keyvisualUrl}
              onChange={(e) => setKeyvisualUrl(e.target.value)}
            />
          </div>
        </div>
        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
            並び順 (数字が小さい順に並びます)
          </p>
        </div>
        <div className="shadow-sm mb-0 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
            <input
              type="text"
              className="p-0 w-100 textarea--eventreport"
              value={sortOrder}
              onChange={(e) => setSortOrder(e.target.value)}
            />
          </div>
        </div>
        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
            ディスクリプション
          </p>
        </div>
        <div className="shadow-sm mb-0 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
            <input
              type="text"
              className="p-0 w-100 textarea--eventreport"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>
        </div>
        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
            公開日
            <span className="message-required d-inline-block mb-2 ml-2">
              必須
            </span>
          </p>
        </div>
        <div className="shadow-sm mb-0 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
            <DatePicker
              selected={publishDatetime}
              onChange={(date) => setPublishDatetime(date)}
              showTimeInput
              withPortal
              dateFormat="yyyy/MM/dd  HH:mm"
            />
          </div>
        </div>
        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
            公開日を表示/非表示
          </p>
        </div>
        <div className="shadow-sm mb-0 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
            <label>
              <input
                type="radio"
                name="is-publish-date-display"
                className=""
                checked={isPublishDateDisplay ? 1 : 0}
                onChange={() => setIsPublishDateDisplay(true)}
              />
              表示
            </label>
            <label>
              <input
                type="radio"
                name="is-publish-date-display"
                className="ml-3"
                checked={!isPublishDateDisplay ? 1 : 0}
                onChange={() => setIsPublishDateDisplay(false)}
              />
              非表示
            </label>
          </div>
        </div>
        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
            パンくずを表示/非表示
          </p>
        </div>
        <div className="shadow-sm mb-0 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
            <label>
              <input
                type="radio"
                name="hide-breadcrumb"
                className=""
                checked={!hideBreadcrumb ? 1 : 0}
                onChange={() => setHideBreadcrumb(false)}
              />
              表示
            </label>
            <label>
              <input
                type="radio"
                name="hide-breadcrumb"
                className="ml-3"
                checked={hideBreadcrumb ? 1 : 0}
                onChange={() => setHideBreadcrumb(true)}
              />
              非表示
            </label>
          </div>
        </div>
        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
            公開/非公開
          </p>
        </div>
        <div className="shadow-sm mb-0 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
            <label>
              <input
                type="radio"
                name="is-deleted"
                className=""
                checked={!isDeleted ? 1 : 0}
                onChange={() => setIsDeleted(false)}
              />
              表示
            </label>
            <label>
              <input
                type="radio"
                name="is-deleted"
                className="ml-3"
                checked={isDeleted ? 1 : 0}
                onChange={() => setIsDeleted(true)}
              />
              非表示
            </label>
          </div>
        </div>
        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
            google検索に表示/非表示
          </p>
        </div>
        <div className="shadow-sm mb-0 bg-white">
          <div className="container col-md-8 col-lg-6 p-3_5">
            <label>
              <input
                type="radio"
                name="is-header-noindex"
                className=""
                checked={!isHeaderNoindex ? 1 : 0}
                onChange={() => setIsHeaderNoindex(false)}
              />
              表示
            </label>
            <label>
              <input
                type="radio"
                name="is-header-noindex"
                className="ml-3"
                checked={isHeaderNoindex ? 1 : 0}
                onChange={() => setIsHeaderNoindex(true)}
              />
              非表示
            </label>
          </div>
        </div>
        <div className="container col-md-8 col-lg-6">
          <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
            本文
          </p>
        </div>
        <Contents
          foreignKeyId={article.id}
          isApp={isApp}
          userAgent={userAgent}
          model={"Article"}
        />
      </main>
      {isNextButtonDisplayed && (
        <div className="fixed-bottom">
          <div className="container col-md-8 col-lg-6 d-flex justify-content-around">
            <div
              className="container d-flex justify-content-around"
              style={{ marginBottom: isApp ? "24px" : "" }}
            >
              <button
                type="button"
                className={`col-6 a-button a-button__top a-button--orange mr-2 w-100 ${
                  isApp == false ? "mb-2" : ""
                }`}
                onClick={(e) => onSubmit(e)}
              >
                作成/更新する
              </button>
            </div>
          </div>
        </div>
      )}
      <ModalAlert
        ref={successRef}
        title="コース作成完了"
        content="コース作成/更新に成功しました。"
        approveFunc={toArticlesPage}
      />
      <ModalAlert
        ref={errorRef}
        title="コース作成失敗"
        content="コース作成に失敗しました。時間をおいてもう一度お試しください。"
      />
      <ModalLoader ref={loaderRef} />
    </div>
  );
};

export default Edit;
